import _ from 'lodash';

export const decorate = (promise) => {
  if (promise && promise.then) {
    return decorateBusy(promise);
  }
  return promise;
};

export const decorateBusy = (promise) => {
  promise.busy = (instance, property) => {
    _.set(instance, property, true);
    promise.finally(() => {
      _.set(instance, property, false);
    });
    return promise;
  };
  const { then } = promise;
  promise.then = (s,e,p) => {
    let thenPromise = then.apply(promise, [s,e,p]);
    return decorate(thenPromise);
  };
  return promise;
};
